/**
 * @generated SignedSource<<10d3f30f4b35182b5de24ba703d0dcaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilizationBarChartComponent_Query$variables = {
  shareKey?: string | null;
  dateCriteria?: string | null;
  componentId?: string | null;
  personIds?: ReadonlyArray<string | null> | null;
  teamIds?: ReadonlyArray<string | null> | null;
  roleIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
};
export type utilizationBarChartComponent_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"utilizationBarChartComponent_viewer">;
  } | null;
};
export type utilizationBarChartComponent_Query = {
  variables: utilizationBarChartComponent_Query$variables;
  response: utilizationBarChartComponent_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateCriteria"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "labelIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_utilization_bar_chart"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_utilization_bar_chart\")"
},
v9 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v10 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v11 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v12 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v13 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v14 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v15 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "utilizationBarChartComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "utilizationBarChartComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "utilizationBarChartComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": [
              (v14/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "concreteType": "UtilizationBarChart",
                "kind": "LinkedField",
                "name": "utilizationBarChart",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UtilizationBarChartElement",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "idleHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "registeredHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "plannedCardHours",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeOffHours",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "775a123838aa9f317f65ee8238d20a99",
    "id": null,
    "metadata": {},
    "name": "utilizationBarChartComponent_Query",
    "operationKind": "query",
    "text": "query utilizationBarChartComponent_Query(\n  $shareKey: String\n  $dateCriteria: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n) {\n  viewer {\n    actualPersonId\n    component(name: \"insight_utilization_bar_chart\")\n    ...utilizationBarChartComponent_viewer_2dlyKa\n    id\n  }\n}\n\nfragment utilizationBarChartComponent_viewer_2dlyKa on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    utilizationBarChart(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds) {\n      data {\n        id\n        personName\n        availableHours\n        projectHours\n        idleHours\n        registeredHours\n        plannedCardHours\n        timeOffHours\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f3ad18f70940fc8dc58d43e11926f28";

export default node;
